import { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import routeConfig from 'app/config/routes';

const CompanySettingsPage = lazy(
  () => import('./components/CompanySettingsPage'),
);

export const companyRouter: RouteObject = {
  path: routeConfig.settings.routes.company.path,
  element: <Outlet />,
  children: [
    {
      index: true,
      element: <CompanySettingsPage />,
    },
    {
      path: routeConfig.settings.routes.company.routes.section.path,
      element: <CompanySettingsPage />,
    },
  ],
};

export default companyRouter;
